import { useTranslation } from 'next-i18next';
import { DataShare } from '../../../../../../../interfaces/interfaces';
import { useSelector } from '../../../../../../../reduxToolkit/typedRedux';
import VyModal from '../../../../../../common/VyModal';

const BoothContactShareModal = ({ report, onClose }: { report: DataShare; onClose: () => void }) => {
  const event = useSelector((state) => state.common.event);

  const { t } = useTranslation();

  const data: { name: string; valueGetter: () => string | undefined }[] = [
    {
      name: t('booth:contact-share.name'),
      valueGetter: () => report.name,
    },
    {
      name: t('booth:contact-share.email'),
      valueGetter: () => report.email,
    },
    {
      name: t('booth:contact-share.message'),
      valueGetter: () => report.message,
    },
    {
      name: t('booth:contact-share.source'),
      valueGetter: () =>
        report.meetingroomid && report.meetingroom ? (report.meetingroom.meetingtype === 'presentation' ? 'Vortrag' : 'Meeting Raum') : 'Stand',
    },
    {
      name: t('booth:contact-share.source-name'),
      valueGetter: () =>
        report.meetingroomid && report.meetingroom
          ? report.meetingroom.meetingtype === 'presentation'
            ? report.meetingroom.name
            : report.meetingroom.contactperson
          : '',
    },
    {
      name: t('booth:contact-share.notes'),
      valueGetter: () => report?.notes && report.notes.map((note: any) => `${note.note}`).join(', '),
    },
    ...(event && event?.modules?.guestmanagement?.settings?.registrationFields?.length > 0
      ? event.modules.guestmanagement.settings.registrationFields
          .filter((element) => element.datetime_deleted === null && element.visibleToExhibitors !== false)
          .map((element) => ({
            name: element.label,
            valueGetter: () =>
              report.registration &&
              report.registration?.registrationFields &&
              report.registration?.registrationFields?.find((f: any) => f.field === element._id)?.value,
          }))
      : []),
  ];

  return (
    <VyModal open={true} onClose={onClose}>
      {(onClose) => (
        <div className="w-full flex flex-col">
          {data.map((row) => (
            <div className="w-full flex flex-row justify-between p-4">
              <b>{row.name}</b>
              <span>{row.valueGetter()}</span>
            </div>
          ))}
        </div>
      )}
    </VyModal>
  );
};
export default BoothContactShareModal;
